if (!customElements.get('product-form')) {
  customElements.define('product-form', class ProductForm extends HTMLElement {
    constructor() {
      super();
      
      this.form = this.querySelector('form');
      this.submitButton = this.querySelector('[type="submit"]');
      
      if (!this.form) {
        console.error('[ProductForm] 找不到 form 元素');
        return;
      }
      
      if (!this.submitButton) {
        console.error('[ProductForm] 找不到 submit 按钮');
        return;
      }
      
      this.variantInputs = this.form.querySelectorAll('input[name="id"]');
      
      this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
      
      // 监听变体切换（来自 block-variant-picker.js 的 variant:change 事件）
      const sectionId = this.dataset.sectionId;
      const productId = this.dataset.productId;
      if (sectionId && productId) {
        document.addEventListener(
          `variant:change:${sectionId}:${productId}`,
          this.onVariantChangePicker.bind(this)
        );
      }
      
      // 同时监听 input[name="id"] 直接 change（兼容其他场景）
      if (this.variantInputs.length) {
        this.variantInputs.forEach(input => {
          input.addEventListener('change', this.onVariantChange.bind(this));
        });
      }
      
      console.log('[ProductForm] 初始化完成');
      console.log('[ProductForm] Bundle 数据:', this.form.dataset.bundleVariants);
    }
    
    // 响应 block-variant-picker.js 的 variant:change 事件
    onVariantChangePicker(event) {
      const { variant } = event.detail;
      if (!variant) return;
      
      // 更新隐藏的 input[name="id"] 值
      const idInput = this.form.querySelector('input[name="id"]');
      if (idInput) {
        idInput.value = variant.id;
      }
      
      // 更新 bundle 数据
      if (window.productBundleData && window.productBundleData[variant.id]) {
        this.form.dataset.bundleVariants = JSON.stringify(window.productBundleData[variant.id]);
      } else if (this.form.dataset.bundleVariants) {
        delete this.form.dataset.bundleVariants;
      }
    }
    
    onVariantChange(event) {
      // 当变体切换时，更新 bundle 数据
      const variantId = event.target.value;
      console.log('[ProductForm] 变体切换:', variantId);
      
      // 如果有存储的 bundle 数据，更新表单
      if (window.productBundleData && window.productBundleData[variantId]) {
        this.form.dataset.bundleVariants = JSON.stringify(window.productBundleData[variantId]);
        console.log('[ProductForm] 更新 bundle 数据:', window.productBundleData[variantId]);
      } else {
        delete this.form.dataset.bundleVariants;
        console.log('[ProductForm] 清除 bundle 数据');
      }
    }
    
    onSubmitHandler(evt) {
      evt.preventDefault();
      console.log('[ProductForm] 表单提交');
      
      // 禁用按钮，防止重复提交
      this.submitButton.setAttribute('disabled', true);
      this.submitButton.classList.add('loading');
      
      const formData = new FormData(this.form);
      const bundleData = this.form.dataset.bundleVariants;
      const quantity = parseInt(formData.get('quantity') || 1);
      
      console.log('[ProductForm] Bundle 数据:', bundleData);
      console.log('[ProductForm] 数量:', quantity);
      
      if (bundleData) {
        try {
          const parsedData = JSON.parse(bundleData);
          console.log('[ProductForm] 解析后的 Bundle 数据:', parsedData);
          this.addBundleToCart(parsedData, quantity);
        } catch (e) {
          console.error('[ProductForm] Bundle 数据解析失败:', e);
          this.handleError({ message: 'Bundle 数据格式错误' });
        }
      } else {
        console.log('[ProductForm] 普通商品，使用默认添加');
        this.addToCart(formData);
      }
    }
    
    addBundleToCart(bundleVariants, quantity) {
      console.log('[ProductForm] 开始添加 Bundle，原始数据:', bundleVariants);
      
      // 【开关】true=主商品模式(1个商品+properties), false=子商品模式(多个商品)
      const USE_MAIN_PRODUCT_MODE = true;
      
      if (USE_MAIN_PRODUCT_MODE) {
        // 主商品模式：只添加1个主商品，子商品信息通过 properties 带过去
        console.log('[ProductForm] 使用主商品模式');
        this.addBundleAsMainProduct(bundleVariants, quantity);
        return;
      }
      
      // 以下是原有的子商品模式逻辑
      console.log('[ProductForm] 使用子商品模式');
      
      // 获取主商品信息用于显示
      const mainTitle = this.form.dataset.bundleMainTitle || '';
      const mainImage = this.form.dataset.bundleMainImage || '';
      const mainPrice = this.form.dataset.bundleMainPrice || '0';
      const mainComparePrice = this.form.dataset.bundleMainComparePrice || '0';
      const mainUrl = this.form.dataset.bundleMainUrl || '';
      const mainVariantTitle = this.form.dataset.bundleMainVariantTitle || '';
      const mainOptionNames = this.form.dataset.bundleMainOptionNames || '';
      
      // 先获取购物车数据，检查是否已存在相同变体组合的 bundle
      fetch('/cart.js', {
        method: 'GET',
        headers: { 'Accept': 'application/json' }
      })
      .then(res => res.json())
      .then(cart => {
        console.log('[ProductForm] 当前购物车:', cart);
        
        // 查找已存在的相同变体组合的 bundle
        const existingBundleId = this.findExistingBundle(cart, bundleVariants);
        
        if (existingBundleId) {
          console.log('[ProductForm] 找到已存在的 Bundle:', existingBundleId);
          // 已存在相同组合，增加数量
          this.updateExistingBundle(cart, existingBundleId, quantity);
        } else {
          console.log('[ProductForm] 创建新的 Bundle');
          // 不存在，创建新的 bundle
          this.createNewBundle(bundleVariants, quantity, mainTitle, mainImage, mainPrice, mainComparePrice, mainUrl, mainVariantTitle, mainOptionNames);
        }
      })
      .catch(error => {
        console.error('[ProductForm] 获取购物车失败:', error);
        // 出错时直接创建新 bundle
        this.createNewBundle(bundleVariants, quantity, mainTitle, mainImage, mainPrice, mainComparePrice, mainUrl, mainVariantTitle, mainOptionNames);
      });
    }
    
    // 查找购物车中是否已存在相同变体组合的 bundle
    findExistingBundle(cart, bundleVariants) {
      const bundleMap = new Map();
      
      // 收集购物车中所有 bundle 的变体 ID
      cart.items.forEach(item => {
        if (item.properties && item.properties._bundle === 'true' && item.properties._bundle_id) {
          const bundleId = item.properties._bundle_id;
          if (!bundleMap.has(bundleId)) {
            bundleMap.set(bundleId, []);
          }
          bundleMap.get(bundleId).push(item.variant_id);
        }
      });
      
      // 检查是否有匹配的 bundle
      const targetIds = bundleVariants.map(item => parseInt(item.id)).sort((a, b) => a - b).join('-');
      console.log('[ProductForm] 目标变体组合:', targetIds);
      
      for (const [bundleId, variantIds] of bundleMap) {
        const existingIds = [...variantIds].sort((a, b) => a - b).join('-');
        console.log('[ProductForm] 已存在的变体组合:', bundleId, existingIds);
        if (existingIds === targetIds) {
          return bundleId;
        }
      }
      
      return null;
    }
    
    // 更新已存在的 bundle 数量
    updateExistingBundle(cart, bundleId, addQuantity) {
      // 找到该 bundle 的所有商品并更新数量
      const updates = {};
      
      cart.items.forEach(item => {
        if (item.properties && item.properties._bundle_id === bundleId) {
          updates[item.key] = item.quantity + addQuantity;
        }
      });
      
      console.log('[ProductForm] 更新 Bundle 数量:', updates);
      
      fetch('/cart/update.js', {
        method: 'POST',
        headers: { 
          'Content-Type': 'application/json',
          'Accept': 'application/json'
        },
        body: JSON.stringify({ updates: updates })
      })
      .then(response => {
        if (!response.ok) {
          return response.json().then(err => Promise.reject(err));
        }
        return response.json();
      })
      .then(data => {
        console.log('[ProductForm] Bundle 数量更新成功:', data);
        this.handleSuccess(data, true);
      })
      .catch(error => {
        console.error('[ProductForm] 更新失败:', error);
        this.handleError(error);
      });
    }
    
    // 创建新的 bundle
    createNewBundle(bundleVariants, quantity, mainTitle, mainImage, mainPrice, mainComparePrice, mainUrl, mainVariantTitle, mainOptionNames) {
      // 生成唯一的 bundle ID (时间戳 + 随机数)
      const bundleId = `${Date.now()}-${Math.random().toString(36).substr(2, 9)}`;
      console.log('[ProductForm] 生成 Bundle ID:', bundleId);
      
      // 构建子商品列表 - 每个子商品都添加到购物车
      const items = [];
      if (Array.isArray(bundleVariants)) {
        bundleVariants.forEach((item, index) => {
          if (typeof item === 'object' && item !== null && item.id) {
            items.push({
              id: parseInt(item.id),
              quantity: quantity,
              properties: {
                '_bundle': 'true',
                '_bundle_id': bundleId,
                '_bundle_index': String(index),
                '_bundle_count': String(bundleVariants.length),
                '_bundle_main_title': mainTitle,
                '_bundle_main_image': mainImage,
                '_bundle_main_price': mainPrice,
                '_bundle_main_compare_price': mainComparePrice,
                '_bundle_main_url': mainUrl,
                '_bundle_main_variant_title': mainVariantTitle,
                '_bundle_main_option_names': mainOptionNames
              }
            });
          }
        });
      }
      
      console.log('[ProductForm] 准备添加的子商品:', items);
      
      if (items.length === 0) {
        console.error('[ProductForm] 没有有效的子商品');
        this.handleError({ message: 'No valid bundle items' });
        return;
      }
      
      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 
          'Content-Type': 'application/json',
          'Accept': 'application/json'
        },
        body: JSON.stringify({ items: items })
      })
      .then(response => {
        console.log('[ProductForm] API 响应状态:', response.status);
        if (!response.ok) {
          return response.json().then(err => Promise.reject(err));
        }
        return response.json();
      })
      .then(data => {
        console.log('[ProductForm] Bundle 添加成功:', data);
        this.handleSuccess(data, true);
      })
      .catch(error => {
        console.error('[ProductForm] 添加失败:', error);
        this.handleError(error);
      });
    }
    
    // 主商品模式：只添加 1 个主商品，子商品信息通过 properties 带过去
    addBundleAsMainProduct(bundleVariants, quantity) {
      console.log('[ProductForm] 主商品模式：添加 Bundle');
      
      // 获取主商品 variant ID
      const formData = new FormData(this.form);
      const mainVariantId = parseInt(formData.get('id'));
      
      if (!mainVariantId) {
        console.error('[ProductForm] 没有找到主商品 ID');
        this.handleError({ message: '无法获取主商品信息' });
        return;
      }
      
      // 构建 properties - 每个子商品一个独立的 property
      const properties = {
        '_bundle_type': 'main',
        '_bundle_count': String(bundleVariants.length)
      };
      
      if (Array.isArray(bundleVariants)) {
        bundleVariants.forEach((item, index) => {
          if (typeof item === 'object' && item !== null && item.id) {
            properties[`_component_${index}_id`] = String(item.id);
            properties[`_component_${index}_title`] = item.title || item.name || '';
            properties[`_component_${index}_price`] = String(item.price || 0);
            properties[`_component_${index}_image`] = item.featured_image ? item.featured_image.src : '';
            // 添加 SKU 作为隐藏属性（以 _ 开头不会在前端显示）
            if (item.sku) {
              properties[`_component_${index}_sku`] = String(item.sku);
            }
            if (item.options && Array.isArray(item.options)) {
              properties[`_component_${index}_options`] = item.options.join(' / ');
            }
          }
        });
      }
      
      console.log('[ProductForm] 主商品 ID:', mainVariantId);
      console.log('[ProductForm] 子商品数量:', bundleVariants.length);
      console.log('[ProductForm] Properties:', properties);
      
      // 添加主商品到购物车
      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 
          'Content-Type': 'application/json',
          'Accept': 'application/json'
        },
        body: JSON.stringify({ 
          items: [{
            id: mainVariantId,
            quantity: quantity,
            properties: properties
          }],
          sections: 'cart-ajax'
        })
      })
      .then(response => {
        console.log('[ProductForm] API 响应状态:', response.status);
        if (!response.ok) {
          return response.json().then(err => Promise.reject(err));
        }
        return response.json();
      })
      .then(data => {
        console.log('[ProductForm] ✅ Bundle 添加成功');
        this.handleSuccess(data, true);
      })
      .catch(error => {
        console.error('[ProductForm] ❌ 添加失败:', error);
        this.handleError(error);
      });
    }
    
    addToCart(formData) {
      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Accept': 'application/json' },
        body: formData
      })
      .then(response => {
        if (!response.ok) {
          return response.json().then(err => Promise.reject(err));
        }
        return response.json();
      })
      .then(data => {
        console.log('[ProductForm] 商品添加成功:', data);
        this.handleSuccess(data, false);
      })
      .catch(error => {
        console.error('[ProductForm] 添加失败:', error);
        this.handleError(error);
      });
    }
    
    handleSuccess(data, isBundle) {
      console.log('[ProductForm] 处理成功回调, isBundle:', isBundle);
      
      // 重新启用按钮
      this.submitButton.removeAttribute('disabled');
      this.submitButton.classList.remove('loading');
      
      // 触发 ajaxProduct:added 事件，让侧滑购物车监听并打开
      document.dispatchEvent(
        new CustomEvent('ajaxProduct:added', { 
          bubbles: true,
          detail: { product: data, isBundle: isBundle }
        })
      );
      
      // 触发购物车刷新事件
      document.documentElement.dispatchEvent(
        new CustomEvent('cart:refresh', { bubbles: true })
      );
    }
    
    handleError(error) {
      console.error('[ProductForm] 处理错误:', error);
      
      this.submitButton.removeAttribute('disabled');
      this.submitButton.classList.remove('loading');
      
      // 显示错误信息
      const errorMessage = error.message || error.description || '添加失败，请重试';
      alert(errorMessage);
    }
  });
}
